import { styled, typography } from '@pulse-web-ui/theme';

export const Container = styled.div<{ $marginBottom?: number }>`
  display: flex;
  flex-direction: column;
  padding: 24px;
  border: ${({ theme }) => `1px solid ${theme?.colors?.neutral['30']}`};
  border-radius: ${({ theme }) => theme.common.radiusS};
`;

export const Title = styled.div<{ $marginBottom?: number }>`
  ${typography.medium16};
  margin-bottom: 16px;
`;

export const FieldName = styled.div<{ $withoutMargin?: boolean }>`
  ${typography.regular16};
  margin-bottom: ${({ $withoutMargin }) => ($withoutMargin ? 0 : 8)}px;
`;

export const Value = styled.div<{ $withoutMargin?: boolean }>`
  ${typography.regular14};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: ${({ $withoutMargin }) => ($withoutMargin ? 0 : 16)}px;
`;
